module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0"
  }, [_c('h4', [_vm._v("我的简历")]), _vm._v(" "), _c('p', {
    staticClass: "py-3"
  }, [_vm._v("点击可以查看或者编辑简历内容")]), _vm._v(" "), _c('a', {
    staticClass: "secondary-btn",
    on: {
      "click": _vm.toHome
    }
  }, [_vm._v("GO"), _c('span', {
    staticClass: "flaticon-next"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "single-feature mb-4 mb-lg-0"
  }, [_c('h4', [_vm._v("投递结果")]), _vm._v(" "), _c('p', {
    staticClass: "py-3"
  }, [_vm._v("点击可以查看简历筛选和应聘进度")]), _vm._v(" "), _c('a', {
    staticClass: "secondary-btn",
    on: {
      "click": _vm.toRecord
    }
  }, [_vm._v("GO"), _c('span', {
    staticClass: "flaticon-next"
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1400cffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 257
// module chunks = 1